module.exports = __webpack_public_path__ + "static/img/9.1dc6a0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/9.png
// module id = J5Ie
// module chunks = 0